import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { useNavigate, useParams } from 'react-router-dom';
import API_BASE_URL from '../Config';

const CategoriaDocumentoForm = () => {
    const { id } = useParams();
    const isEditing = !!id;
    const navigate = useNavigate();

    const [form, setForm] = useState({ valor: '', nombre: '' });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isEditing) fetchCategoria();
    }, []);

    const fetchCategoria = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_BASE_URL}/categorias-documento/${id}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await response.json();
            setForm({ valor: data.valor, nombre: data.nombre ?? '' });
        } catch (error) {
            Swal.fire('Error', 'No se pudo cargar la categoría', 'error');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.valor.trim()) {
            Swal.fire('Atención', 'El valor es obligatorio', 'warning');
            return;
        }

        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const url = isEditing
                ? `${API_BASE_URL}/categorias-documento/${id}`
                : `${API_BASE_URL}/categorias-documento`;
            const method = isEditing ? 'PUT' : 'POST';

            const response = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(form)
            });

            if (!response.ok) throw new Error('Error al guardar la categoría');

            Swal.fire('Éxito', `Categoría ${isEditing ? 'actualizada' : 'creada'} correctamente`, 'success');
            navigate('/parametrizacion/categorias-documento');
        } catch (error) {
            Swal.fire('Error', error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid py-5 px-lg-5" style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
            <div className="mb-4">
                <h2 className="fw-bolder text-dark mb-1">{isEditing ? 'Editar Categoría' : 'Nueva Categoría de Documento'}</h2>
                <p className="text-muted mb-0">Parametrización del sistema</p>
            </div>

            <div className="card border-0 shadow-sm rounded-4 p-4 bg-white" style={{ maxWidth: '500px' }}>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label className="form-label fw-bold">Valor <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className="form-control rounded-pill"
                            placeholder="Ej: PERS, CONT..."
                            maxLength={10}
                            value={form.valor}
                            onChange={(e) => setForm({ ...form, valor: e.target.value.toUpperCase() })}
                        />
                    </div>

                    <div className="mb-4">
                        <label className="form-label fw-bold">Nombre <span className="text-muted fw-normal">(opcional)</span></label>
                        <input
                            type="text"
                            className="form-control rounded-pill"
                            placeholder="Ej: Personal, Contrato..."
                            maxLength={50}
                            value={form.nombre}
                            onChange={(e) => setForm({ ...form, nombre: e.target.value })}
                        />
                    </div>

                    <div className="d-flex gap-2">
                        <button
                            type="submit"
                            className="btn btn-primary rounded-pill fw-bold px-4"
                            disabled={loading}
                        >
                            {loading ? <span className="spinner-border spinner-border-sm me-2"></span> : null}
                            {isEditing ? 'Actualizar' : 'Guardar'}
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary rounded-pill px-4"
                            onClick={() => navigate('/parametrizacion/categorias-documento')}
                        >
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CategoriaDocumentoForm;